import axios from 'axios';
import { baseUrl } from '../../config';

export function aiApi(path, method = 'get', data) {
  let token = '';
  try { token = JSON.parse(localStorage.getItem('token') || '""'); } catch (e) { token = ''; }
  return axios({
    url: baseUrl + '/admin/diagnostic/ai/' + path,
    method, timeout: 30000, withCredentials: true,
    headers: { Authorization: token, 'Content-Type': 'application/json' },
    params: method === 'get' ? data : undefined,
    data: method === 'get' ? undefined : data
  }).then(res => {
    if (Number(res.data.code) !== 200) throw new Error(res.data.msg || '请求失败');
    return res.data.data;
  });
}

export const clone = value => JSON.parse(JSON.stringify(value));
export const emptyCriteria = () => ({ category: '', any_tags: [], must_tags: [], exclude_tags: [], requirements: [], sort: [] });
export function normalizeCriteria(value) {
  const result = { ...emptyCriteria(), ...(value || {}) };
  ['any_tags', 'must_tags', 'exclude_tags', 'requirements', 'sort'].forEach(key => { if (!Array.isArray(result[key])) result[key] = []; });
  if (Array.isArray(result.plans)) result.plans = result.plans.map(plan => ({ ...plan, criteria: normalizeCriteria(plan.criteria) }));
  return result;
}
export const kindNames = { tag: '产品标签', number: '数值参数', boolean: '有无成分', text: '文本参数' };
